import React from "react";
import { Server, Database, ShieldCheck, Activity, Cpu, Cloud, Layers, CheckCircle2 } from "lucide-react";
import "./WhatIBuild.css";

const capabilitiesData = [
  {
    icon: Server,
    title: "Scalable Backend Architecture",
    description:
      "Engineering robust backend services and modular monoliths in Node.js, NestJS, Express.js, and Flask with clean MVC patterns and performance optimization.",
    deliverables: ["Modular Monolith Design", "RESTful API Development", "Middleware Architecture", "Fault-Tolerant Workflows"],
  },
  {
    icon: Database,
    title: "Database Design & Optimization",
    description:
      "Designing normalized relational and document schemas with PostgreSQL, MySQL, MongoDB, and Redis with query indexing and caching strategies.",
    deliverables: ["PostgreSQL & Prisma ORM", "Redis Caching Strategies", "Schema Normalization", "Query Tuning & PostGIS"],
  },
  {
    icon: Activity,
    title: "Realtime & Queue Systems",
    description:
      "Building event-driven pipelines, background workers, and realtime synchronization using WebSockets (Socket.IO) and BullMQ distributed queues.",
    deliverables: ["Socket.IO Realtime Data", "BullMQ Job Processing", "Event-Driven Workflows", "Sliding-Window Throttling"],
  },
  {
    icon: Layers,
    title: "Business Software (ERP/CRM/LMS)",
    description:
      "Translating complex business operations into dependable software systems spanning automated billing, inventory control, and multi-tenant workflows.",
    deliverables: ["Automated Billing Engines", "Inventory Management", "Role-Based LMS Portals", "Customer Service CRMs"],
  },
  {
    icon: ShieldCheck,
    title: "Authentication & Security Protocols",
    description:
      "Implementing industry-standard security practices including JWT, Google OAuth, OTP verification, bcrypt hashing, Helmet.js, and granular RBAC.",
    deliverables: ["Role-Based Access Control (RBAC)", "JWT & OAuth2 Integration", "Rate Limiting & Throttling", "Secure API Endpoints"],
  },
  {
    icon: Cloud,
    title: "Cloud Deployment & CI/CD",
    description:
      "Containerizing services with Docker and deploying to AWS (EC2, ECS, RDS, S3), Render, and Vercel with automated GitHub Actions CI/CD pipelines.",
    deliverables: ["AWS Infrastructure (EC2, RDS, S3)", "Docker Containerization", "GitHub Actions CI/CD", "Nginx & SSL Configuration"],
  },
];

const WhatIBuild = () => {
  return (
    <section id="capabilities" className="section capabilities-section">
      <div className="container">
        
        {/* SECTION HEADER */}
        <div className="section-header">
          <div className="eyebrow">04 / Core Competencies</div>
          <h2 className="section-title">
            Engineering <em>Capabilities</em>
          </h2>
          <p className="section-subtitle">
            Specialized engineering proficiencies developed across production deployments, high-throughput systems, and end-to-end software delivery.
          </p>
        </div>

        {/* CAPABILITIES GRID */}
        <div className="capabilities-grid">
          {capabilitiesData.map((cap, index) => {
            const Icon = cap.icon;
            return (
              <div key={index} className="capability-card">
                <div className="cap-icon-box">
                  <Icon size={22} className="cap-icon" />
                </div>
                <h3 className="cap-title">{cap.title}</h3>
                <p className="cap-desc">{cap.description}</p>
                <div className="cap-deliverables">
                  {cap.deliverables.map((item, idx) => (
                    <div key={idx} className="cap-deliverable-item">
                      <CheckCircle2 size={13} className="cap-deliv-check" />
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default WhatIBuild;
